class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}

customElements.define('cart-remove-button', CartRemoveButton);
window.promoClick = true;
window.FreeProductCalled = false;
class CartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
        // this.removeAndFreeProduct();
        // this.freeProductViaAtcRemove();

          // let selfThis = this;
          // if(window.promoClick){
          //   $('#EmraldpromotionPopup .product-button').click(function(){
          //     let $this = $(this);
          //     selfThis.promotionFreeProduct($this)
          //   })
          //  window.promoClick = false; 
          // }
      if(window.FreeProductCalled == false){
        window.FreeProductCalled = true;
        this.freeProduct();
        setTimeout(function(){
          window.FreeProductCalled = false;
        },1500);
        console.log("HHHHHHHHEEEERRREEEE")
      }
      // this.bundleProduct();
      // this.GiftAddtoCart();
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'),event.target.dataset.key);
    }

    getSectionsToRender() {
        return [{
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'announcement-bar-cart-deal',
                section: 'announcement-bar-cart-deal',
                selector: '.announcement-bar-cart-aov'
            }
        ];
    }

    updateQuantity(line, quantity, name,key) {
        this.enableLoading(line);
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ... { body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                if(key && quantity) GA4.added_or_removed(key,quantity);
                // this.removeAndFreeProduct();
                const parsedState = JSON.parse(state);
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
                this.updateLiveRegions(line, parsedState.item_count);

                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
                }

                this.disableLoading();
                // this.bundleProduct();
                // this.promotionProduct();
                EmraldLabsProtection.Checkproduct();
                EmraldLabsProtection.CookieInit();
                EmraldLabsProtection.Init();
                GA4.cart_item(parsedState);
            }).catch(() => {
                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                errors.textContent = window.cartStrings.error;
                this.disableLoading();
            });
    }
  
    freeProductViaAtcRemove(){
      const $this = this;
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            var ForceUpdate = { updates: {} },
                Items = cart.items,
                ForceUpdatestatus = false;
            for (let i = 0; i < Items.length; i++) {
                var Item = Items[i];
                if (Item.id == window.settings.freeProduct) {
                  if(!Item.properties){
                    ForceUpdate.updates[Item.key] = 0;
                    ForceUpdatestatus = true;  
                  }
                }
            }
            if (ForceUpdatestatus) {
                jQuery.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    data: ForceUpdate,
                    dataType: 'json',
                    success: function(res) {
                        $this.Donotrecallcart();
                    }
                });
            }
        });
    }
  
    freeProductUpdate(line, quantity) {
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.freeProductGetSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ... { body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.productId = parsedState.id;
                this.freeProductGetSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
                this.updateLiveRegions(line, parsedState.item_count);
                EmraldLabsProtection.Checkproduct();
                EmraldLabsProtection.CookieInit();
                EmraldLabsProtection.Init();
                GA4.cart_item(parsedState);
            }).catch(() => {});
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

            lineItemError
                .querySelector('.cart-item__error-text')
                .innerHTML = window.cartStrings.quantityError.replace(
                    '[quantity]',
                    quantityElement.value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }
  
    freeProductGtSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }
  
    freeProductGetSectionsToRender() {
        return [{
            id: 'CartDrawer',
            section: 'cart-drawer',
            selector: '.drawer__inner'
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: 'announcement-bar-cart-deal',
            section: 'announcement-bar-cart-deal',
            selector: '.announcement-bar-cart-aov'
          }
        ];
    }

    freeProduct() {
      // return;
      // console.log("--------freeProduct")
        // this.bundleProduct();
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            const _this = this;
            var Items = cart.items,
                UnlockedItem = [],
                ExfreeItem = [],
                NeedtoRemove = [],
                NeedtoAdd = [],
                Rp = { updates: {} },
                Needtoupdate = false,
                Product1 = 46208881197214,
                Product2 = 46208897220766,
                Product3 = 46208901677214,
                firstprice = 11999,
                secondprice = 19999,
                thirdprice = 29999;

            if (cart.total_price > firstprice) {
                UnlockedItem.push(Product1);
            }
            if (cart.total_price > secondprice) {
                UnlockedItem.push(Product2);
            }
            if (cart.total_price > thirdprice) {
                UnlockedItem.push(Product3);
            }
            for (var i = 0; i < Items.length; i++) {
                var Item = Items[i];
                if (Item.id == Product1 || Item.id == Product2 || Item.id == Product3) {
                    if (Item.properties['_free-product']) {
                        ExfreeItem.push(Item.id);
                    }
                }
            }
            for (var j = 0; j < ExfreeItem.length; j++) {
                var Ex = ExfreeItem[j];
                if (jQuery.inArray(Ex, UnlockedItem) == -1) {
                    Needtoupdate = true;
                    NeedtoRemove.push(Ex);
                    Rp.updates[Ex] = 0;
                }
            }

            for (var k = 0; k < UnlockedItem.length; k++) {
                var Fr = UnlockedItem[k];
                if (jQuery.inArray(Fr, ExfreeItem) == -1) {
                    Needtoupdate = true;
                    NeedtoAdd.push(Fr);
                }
            }

            if (Needtoupdate) {
              if (NeedtoRemove.length) {
                  this.freeProductLineItem(0)
              } else if (NeedtoAdd.length) {
                  _this.fatc(NeedtoAdd);
              }
            }
            fetch('/cart.js').then(res => res.json()).then((cart) => {
                var ForceUpdate = { updates: {} },
                    Items = cart.items,
                    ForceUpdatestatus = false;
                for (i = 0; i < Items.length; i++) {
                    var Item = Items[i];
                    if (Item.id == Product1 || Item.id == Product2 || Item.id == Product3) {
                        if (Item.quantity > 1) {
                            ForceUpdate.updates[Item.id] = 1;
                            ForceUpdatestatus = true;
                        }
                    }
                    // if (Item.properties && Item.properties['_free-product']) {
                    //     if (Item.id != Product1 || Item.id != Product2 || Item.id != Product3) {
                    //         ForceUpdate.updates[Item.id] = 0;
                    //         ForceUpdatestatus = true;
                    //     }
                    // }
                }
                if (ForceUpdatestatus) {
                    jQuery.ajax({
                        type: 'POST',
                        url: '/cart/update.js',
                        data: ForceUpdate,
                        dataType: 'json',
                        success: function(res) {
                            _this.Donotrecallcart();
                        }
                    });
                }
            });
        });
    }

    GiftAddtoCart(){
      if(window.settings.GiftProductfunction == true){
        var __this = this;
        window.settings.GiftProductfunction = false;
        $(document).on('click',"#gift_popup .add_to_cart_btn",function() {
          var $vid = $(this).data('variant'),
              formData = { 'items': [] };
          $(this).html("ADDING...")
          formData.sections_url = window.location.pathname;
          formData.sections = __this.freeProductGetSectionsToRender().map((section) => section.section);
          $("#gift_popup .add_to_cart_btn").prop('disabled', true);
          formData.items.push({ 'id': $vid, 'quantity': 1, properties: { '_gift_product': 'true' } })
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(response => {
            return response.text();
          }).then((state) => {
            if($('#gift_popup .gift_product_content').hasClass('slick-initialized ')){
              $('#gift_popup .gift_product_content').slick('unslick');
            }
            $('#gift_popup').hide().remove();

            const parsedState = JSON.parse(state);
            __this.productId = parsedState.id;
            __this.freeProductGetSectionsToRender().forEach((section => {
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = __this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
           }).catch((error) => {
            console.log("error",error)
           }); 
        });
      }
    }

    bundleProduct(){
      fetch('/cart.js').then(res => res.json()).then((cart) => {
        var CartProductArray = [];
        var formData = { 'items': [] };
        var UpdateData = { updates: {} };
        formData.sections_url = window.location.pathname;
        formData.sections = this.freeProductGetSectionsToRender().map((section) => section.section);
        
        UpdateData.sections_url = window.location.pathname;
        UpdateData.sections = this.freeProductGetSectionsToRender().map((section) => section.section);
        
        CartProductArray = cart.items.map(function (item) { return item.product_id;});
        CartProductArray = $.unique(CartProductArray);

        // 7636360200350
        // FREE GIFT START
         var $GiftProducts = [8104948138142];
        if(cart.total_price >= 13000){
          var GiftCount = 0;
          for(var i=0; i < cart.items.length ; i++){
            if($.inArray(cart.items[i].product_id,$GiftProducts) > -1){
              GiftCount = GiftCount + cart.items[i].quantity;
            }
          }
          if(GiftCount == 0){
            // SHOW POPUP
              if($("#gift_popup").length == 0){
                var GiftPopup = $("#gift-popup-template").html();
                $('body').append(GiftPopup);
  
                $('#gift_popup .gift_product_content').slick({
                  infinite: false,
                  slidesToShow: 4,
                  prevArrow:'<button class="slick-prev slick-arrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"><g><g><path d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12 C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084 c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864 l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"></path></g></g></svg></button>',
                  nextArrow:'<button class="slick-next slick-arrow" ><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492.004 492.004" style="enable-background:new 0 0 492.004 492.004;" xml:space="preserve"> <g><g><path d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12 c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028 c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265 c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"></path></g></g></svg></button>',
                  responsive: [
                    {
                      breakpoint: 750,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 390,
                      settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]
                }); 
              }
          }else if(GiftCount > 1){
            // REMOVE SECOND ONE
            var FirstStatus = false;
            for(var i=0; i < cart.items.length ; i++){
              if($.inArray(cart.items[i].product_id,$GiftProducts) > -1){
                if(FirstStatus == false){
                  var FirstStatus = true;
                  UpdateData.updates[cart.items[i].key] = 0;
                }
              }
            }
          }
        }else{
          // CHECK IF EXIST REMOVE
          for(var i=0; i < cart.items.length ; i++){
            if($.inArray(cart.items[i].product_id,$GiftProducts) > -1){
              UpdateData.updates[cart.items[i].key] = 0;
            }
            if(cart.items[i].properties && cart.items[i].properties['_gift_product']){
              UpdateData.updates[cart.items[i].key] = 0;
            }
          }
        }
        // FREE GIFT END

        for(var i=0; i < CartProductArray.length ; i++){
          if($.inArray(CartProductArray[i],window.BundleArray) > -1){
            var $qty = 0 
            for(var j=0; j < cart.items.length ; j++){
              if(cart.items[j].product_id == CartProductArray[i]){
                $qty += cart.items[j].quantity;
              }
            }
            if($qty > 0){
              var ExistStatus = false;
              for(var a=0; a < cart.items.length ; a++){
                if(cart.items[a].properties && cart.items[a].properties['_free-with'] == CartProductArray[i]){
                  ExistStatus = true;
                }
              }
              if(ExistStatus){
                // setQty
                for(var a=0; a < cart.items.length ; a++){
                  if(cart.items[a].properties && cart.items[a].properties['_free-with'] == CartProductArray[i]){
                    if($qty != cart.items[a].quantity){
                      UpdateData.updates[cart.items[a].key] = $qty;
                    }
                    // ExistStatus = true;
                  }
                }
              }else{
                  // else
                  // Add product to cart 
                  var Freeproducts = window.FreeProductObject[CartProductArray[i]];
                  for(var k=0; k < Freeproducts.length; k++){
                    formData.items.push({ 'id': Freeproducts[k],'quantity': $qty, properties:{'_free-with':CartProductArray[i], '_free-text':window.MessageObject[CartProductArray[i]]} })
                  }
              }
            }else{
              // remove if exist
            }
          }
        }

        for(var b=0; b < cart.items.length ; b++){
          if(cart.items[b].properties && cart.items[b].properties['_free-with']){
            if($.inArray(cart.items[b].properties['_free-with'],CartProductArray) == -1){
              UpdateData.updates[cart.items[b].key] = 0;
            }
            // ExistStatus = true;
          }
        }
        
        if(jQuery.isEmptyObject(UpdateData.updates) == false){
            fetch('/cart/update.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(UpdateData)}).then(response => {
              return response.text();
            }).then((state) => {
              if(formData.items.length){
                fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
                  return response.text();
                }).then((state) => {
                 const parsedState = JSON.parse(state);
                  this.productId = parsedState.id;
                  this.freeProductGetSectionsToRender().forEach((section => {
                      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                  }));
                 }).catch((error) => {
                   console.log("error",error);
                 }); 
              }else{
                const parsedState = JSON.parse(state);
                this.productId = parsedState.id;
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');
    
                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
                
                this.freeProductGetSectionsToRender().forEach((section => {
                    const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));
              }
           }).catch((error) => {
             console.log("error",error);
           }); 
        }else if(formData.items.length){
          fetch('/cart/add.js', { method: 'POST',headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData)}).then(response => {
            return response.text();
          }).then((state) => {
           const parsedState = JSON.parse(state);
            this.productId = parsedState.id;
            this.freeProductGetSectionsToRender().forEach((section => {
                const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }));
           }).catch((error) => {
             console.log("error",error);
           }); 
        }
      });

      
      return;
      var CartProductArray = [],
      CartItemArray = [],
      BundleFreeItem = [],
      BundleNeedtoremove = [],
      Rp = { updates: {} },
      formData = { 'items': [] },
      UpdateStatus = false;
      fetch('/cart.js').then(res => res.json()).then((cart) => {
        CartItemArray = cart.items.map(function (item) { return item.id;})
        CartItemArray = $.unique(CartProductArray);
        
        if (jQuery.inArray(window.bundle_pid, CartProductArray) == -1) {
          // REMOVE FREE PRODUCT
          for(i=0; i < window.fbp_list.length ; i++){
            Rp.updates[window.fbp_list[i]] = 0;
            UpdateStatus = true;
          }
          Rp.sections = this.freeProductGetSectionsToRender().map((section) => section.section);
          Rp.sections_url = window.location.pathname;
        }else{
          // ADD FREE PRODUCT
          var TotalQty = 0;
          for(i=0; i < cart.items.length ; i++){
            if(cart.items[i].product_id == window.bundle_pid){
              TotalQty += cart.items[i].quantity;
            }
          }
          
          for(i=0; i < window.fbp_list.length ; i++){
            if (jQuery.inArray(window.fbp_list[i], CartItemArray) == -1) {
              formData.items.push({ 'id': window.fbp_list[i], 'quantity': TotalQty, properties: { '_free-bundle-product': 'true' } })
            }else{
              Rp.updates[window.fbp_list[i]] = TotalQty;
              UpdateStatus = true;
            }
          }

          formData.sections = this.freeProductGetSectionsToRender().map((section) => section.section);
          formData.sections_url = window.location.pathname;
        }

        if(UpdateStatus){
            fetch('/cart/update.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(Rp)}).then((response) => {
                return response.text();
            }).then((state) => {
              if(formData.items.length){
                 fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(response => {
                     return response.text();
                 }).then((state) => {
                    this.UpdateCart(state);
                 }).catch((error) => {
                 }); 
              }else{
                this.UpdateCart(state);
              }
            }).catch((error) => {
              console.log("error",error)
            });
          }else if(formData.items.length){
             fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(response => {
              return response.text();
            }).then((state) => {
               this.UpdateCart(state);
             }).catch((error) => {
              console.log("error",error)
             }); 
          }
        
      });
    }
  
    UpdateCart(state){
      const parsedState = JSON.parse(state);
      this.productId = parsedState.id;
      this.freeProductGetSectionsToRender().forEach((section => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      if(parsedState.item_count == 0){
        $('cart-drawer-items, cart-drawer').addClass("is-empty");
      }
    }
  
    fatc(Products) {
        if (Products.length) {
            let formData = { 'items': [] };
            for (var i = 0; i < Products.length; i++) {
                if (Products[i]) {
                    formData.items.push({ 'id': Products[i], 'quantity': 1, properties: { '_free-product': 'true' } })
                }
            }
            if (formData.items.length) {
                fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(response => {
                    this.Donotrecallcart()
                }).catch((error) => {
                    this.Donotrecallcart()
                });
            } else {
                this.Donotrecallcart()
            }
        } else {
            this.Donotrecallcart()
        }
    }
  
    Donotrecallcart() {
        this.freeProductLineItem(1)
    }
  
    freeProductLineItem(qtyItem) {
        const __this = this;
        fetch('/cart.js').then(res => res.json()).then((parsedState) => {
            var cartItems = parsedState.items;
            for (let item = 0; item < cartItems.length; item++) {
                if (cartItems[item].properties_all && cartItems[item].properties_all['_free-product'] || cartItems[item].properties && cartItems[item].properties['_free-product']) {
                    var lineItemCount = parseInt(item) + 1;
                    __this.freeProductUpdate(lineItemCount, qtyItem)
                }
            }
        });
    }
  
    removeAndFreeProduct() {
        const _this = this;
        fetch('/cart.js').then(res => res.json()).then((cart) => {
            var ForceUpdate = { updates: {} },
                Items = cart.items,
                ForceUpdatestatus = false;
            for (let i = 0; i < Items.length; i++) {
                var Item = Items[i];
                if (Item.id == window.settings.limitedProduct) {
                    if (Item.quantity > 1) {
                        ForceUpdate.updates[Item.id] = 1;
                        ForceUpdatestatus = true;
                      _this.updateQuantity(i+1, 1, "updates[]",Item.key);
                    }
                }
                if (Item.properties && Item.properties['_free-product']) {
                    if (Item.quantity > 1) {
                        ForceUpdate.updates[Item.id] = 1;
                        ForceUpdatestatus = true;
                        _this.updateQuantity(i+1, 1, "updates[]",Item.key);
                    }
                }
            }
            // if (ForceUpdatestatus) {
            //     jQuery.ajax({
            //         type: 'POST',
            //         url: '/cart/update.js',
            //         data: ForceUpdate,
            //         dataType: 'json',
            //         success: function(res) {
            //             _this.Donotrecallcart();
            //         }
            //     });
            // }
        });
    }
    
    promotionFreeProduct($this){
      let $variant = $this.data('variant'),
          formData = { 'items': [] },
          $thisIs = this;
      formData.items.push({ 'id': $variant,'quantity': 1, properties:{'_Emrald-promotion':'true'} });  
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then((response) => response.json()).then((response) => {
        let qtyItem = response.items[0].quantity;  
        $thisIs.freeProductUpdate(1, qtyItem);
        $('#EmraldpromotionPopup').removeClass('active');
        $('.EmraldpromotionPopup_wrapper').find('.overlay').removeClass('active');
        // $thisIs.promotionProduct();
      }).catch((error) => {
          console.log(error)
      });
    }
  
    promotionProduct() {
      return;
      var _$this = this;
      fetch('/cart.js').then(res => res.json()).then((cart) => {
          var cartData = cart.items,
              firstCheck = false,
              freeProductQty = 0,
              mainProductQty = 0,
              ForceUpdate = { updates: {} },
              checkStaus = false;

          if(window.promotion && window.promotionVid){
            for (let index = 0; index < cartData.length; index++) {
                var Item = cartData[index];
                if (window.promotion.includes(cartData[index].id)) {
                    mainProductQty += Item.quantity;
                }
               if (window.promotionVid.includes(cartData[index].id)) {
                 freeProductQty += cartData[index].quantity;
              }
            }
          }
          
          if(freeProductQty > mainProductQty){
            var needToRemove = freeProductQty - mainProductQty;
            for (let count = 0; count < cartData.length; count++) {
              var Item = cartData[count];
               if (window.promotionVid.includes(cartData[count].id) && needToRemove > 0) {
                 if(needToRemove > Item.quantity){
                    ForceUpdate.updates[Item.id] = 0;
                    checkStaus = true;
                    needToRemove = needToRemove - Item.quantity;
                 }else{
                   ForceUpdate.updates[Item.id] = Item.quantity - needToRemove;
                   checkStaus = true;
                   needToRemove = needToRemove - (Item.quantity - needToRemove);
                 }
               }
            }
          }
          if (checkStaus) {
              jQuery.ajax({
                  type: 'POST',
                  url: '/cart/update.js',
                  data: ForceUpdate,
                  dataType: 'json',
                  success: function(res) {
                     _$this.updateQuantity(1, res.items[0].quantity, "updates[]",res.items[0].key)
                  }
              });
          } else {
            if (freeProductQty < mainProductQty && mainProductQty != 0) {
              $('.emraldpromotion__product').slick('resize');
              $('#EmraldpromotionPopup').addClass('active');
              $('.EmraldpromotionPopup_wrapper').find('.overlay').addClass('active');
              $('.emraldpromotion__product').slick('resize');
            }
          }
      }).catch((error) => {
          console.log(error);
      });
    }
    
    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');
    }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ... { body } });
            }, 300))
        }
    });
};